import { buttonShuffle } from "../helpers-board.js";

/*
 * Sets the inner text of buttons to just 'Button' no identifier 
 */
function removeNumbers({ board, buttons, initialPositions }) {
  buttons.forEach((button) => {
    button.innerText = 'Button';
  })
  buttonShuffle({ board, buttons, initialPositions });
}

export default removeNumbers;

